module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.ttf?a33808e1480bbdc1273cce84ed5c288c";